import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./sideNav.scss";
import homeInactive from "../../assets/images/sidebar/dashboard.svg";
import homeActive from "../../assets/images/sidebar/dashboard_active.svg";
import storeInactive from "../../assets/images/sidebar/storefront.svg";
import storeActive from "../../assets/images/sidebar/storefront_active.svg";
import catalogueInactive from "../../assets/images/sidebar/collection.svg";
import catalogueActive from "../../assets/images/sidebar/collection_active.svg";
import ordersInactive from "../../assets/images/sidebar/orders.svg";
import ordersActive from "../../assets/images/sidebar/orders_active.svg";
import contactsInactive from "../../assets/images/sidebar/contact.svg";
import contactsActive from "../../assets/images/sidebar/contact_active.svg";
import financialsInactive from "../../assets/images/sidebar/transaction.svg";
import financialsActive from "../../assets/images/sidebar/trannsaction_active.svg";
import promotionsInactive from "../../assets/images/sidebar/promotions.svg";
import promotionsActive from "../../assets/images/sidebar/promotion_active.svg";
import settingsInactive from "../../assets/images/sidebar/settings.svg";
import settingsActive from "../../assets/images/sidebar/settings_active.svg";
import helpInactive from "../../assets/images/sidebar/helpCenter.svg";
import helpActive from "../../assets/images/sidebar/helpCenter_active.svg";
import brandsInactive from "../../assets/images/sidebar/brands.svg";
import brandsActive from "../../assets/images/sidebar/brands_active.svg";
import listingsInactive from "../../assets/images/sidebar/listings.svg";
import listingsActive from "../../assets/images/sidebar/listings_active.svg";
import finacialsInactive from "../../assets/images/sidebar/finacials.svg";
import finacialsActive from "../../assets/images/sidebar/finacials_active.svg";
import plansInactive from "../../assets/images/sidebar/plans.svg";
import plansActive from "../../assets/images/sidebar/plans_active.svg";
import reviewInactive from "../../assets/images/sidebar/review.svg";
import reviewActive from "../../assets/images/sidebar/review_active.svg";
import masterDataActive from "../../assets/images/masterDataActive.png";
import masterDataInactive from "../../assets/images/mastetdataInActive.svg";
import { getUserRole } from "../../utils/common";
import haderLogo from "../../assets/images/shopezsidelogo.png";
import NoImage from "../../assets/images/man.png";
import { getMethod } from "../../utils/services/api";
import urls from "../../utils/services/apiUrl.json"

const navLinks = [
    {
        image: storeInactive,
        url: "/aboutStore",
        name: "About Store",
        activeImage: storeActive,
        status: 10,
        step: 0
    },
    {
        image: brandsInactive,
        url: "/brands",
        name: "Brands",
        activeImage: brandsActive,
        status: 10,
        step: 0
    },
    {
        image: listingsInactive,
        url: "/addProduct",
        name: "Listings",
        activeImage: listingsActive,
        status: 10,
        step: 0
    },
    {
        image: finacialsInactive,
        url: "/financials",
        name: "Financials",
        activeImage: finacialsActive,
        status: 33,
        step: 1
    },
    // {
    //     image: plansInactive,
    //     url: "/plans",
    //     name: "Plans",
    //     activeImage: plansActive,
    //     status: 90,
    //     step: 3
    // },
    {
        image: reviewInactive,
        url: "/review",
        name: "Review",
        activeImage: reviewActive,
        status: 100,
        step: 4
    },
];

const navLinksAfterOnboarding = [
    {
        image: homeInactive,
        url: "/home",
        name: "Dashboard",
        activeImage: homeActive
    },
    {
        image: storeInactive,
        url: "/stores",
        name: "Stores",
        activeImage: storeActive,
    },
    {
        image: brandsInactive,
        url: "/brands",
        name: "Brands",
        activeImage: brandsActive,
    },
    {
        image: catalogueInactive,
        url: "/catalogue",
        name: "Catalogue",
        activeImage: catalogueActive,
        submenus: [
            {
                image: homeInactive,
                url: "/catalogue/listing",
                name: "Listing",
                parent: "/catalogue",
            },
            // {
            //     image: homeInactive,
            //     url: "/catalogue/collection",
            //     name: "Collection",
            //     parent: "/catalogue",
            // },
        ],
    },
    {
        image: ordersInactive,
        url: "/orders",
        name: "Orders",
        activeImage: ordersActive,
    },
    {
        image: contactsInactive,
        url: "/contacts",
        name: "Contacts",
        activeImage: contactsActive,
        submenus: [
            {
                image: homeInactive,
                url: "/contacts/suppliers",
                name: "Suppliers"
            },
            {
                image: homeInactive,
                url: "/contacts/customers",
                name: "Customers"
            },
        ],
    },
    // {
    //     image: financialsInactive,
    //     url: "/financials",
    //     name: "Financials",
    //     activeImage: financialsActive,
    // },
    {
        image: financialsInactive,
        url: "/transaction",
        name: "Transactions",
        activeImage: financialsActive,
    },
    // {
    //     image: promotionsInactive,
    //     url: "/promotions",
    //     name: "Promotions",
    //     activeImage: promotionsActive,
    //     submenus: [
    //         {
    //             image: homeInactive,
    //             url: "/promotions/banners",
    //             name: "Banners"
    //         },
    //         {
    //             image: homeInactive,
    //             url: "/promotions/deals",
    //             name: "Deals"
    //         },
    //         {
    //             image: homeInactive,
    //             url: "/promotions/discounts",
    //             name: "Discounts"
    //         },
    //     ],
    // },
    {
        image: settingsInactive,
        url: "/settings",
        name: "Settings",
        activeImage: settingsActive,
        submenus: [
            {
                image: homeInactive,
                url: "/settings/generalSettings",
                name: "General",
            },
            {
                image: homeInactive,
                url: "/settings/faqs",
                name: "FAQs"
            },
            // {
            //     image: homeInactive,
            //     url: "/settings/plans",
            //     name: "Plans"
            // },
            // {
            //     image: homeInactive,
            //     url: "/settings/bankDetails",
            //     name: "Bank Details",
            // },
            {
                image: financialsInactive,
                url: "/settings/financials",
                name: "Financials",
            },
            {
                image: homeInactive,
                url: "/settings/shippingDelivery",
                name: "Shipping & Delivery",
            },
        ],
    },
    // {
    //     image: helpInactive,
    //     url: "/helpCenter",
    //     name: "Help center",
    //     activeImage: helpActive,
    // },
];

const navLinksAfterOnboardingAdmin = [
    {
        image: catalogueInactive,
        url: "/onlineenquiry",
        name: "Online Enquiry",
        activeImage: catalogueActive,
    },
    {
        image: storeInactive,
        url: "/stores",
        name: "Stores",
        activeImage: storeActive,
    },
    {
        image: ordersInactive,
        url: "/orders",
        name: "Orders",
        activeImage: ordersActive,
    },
    {
        image: ordersInactive,
        url: "/campaign",
        name: "Campaign",
        activeImage: ordersActive,
    },
    {
        image: masterDataInactive,
        url: "/masterdata",
        name: "Master Data",
        activeImage: masterDataActive,
        submenus: [
            {
                image: homeInactive,
                url: "/masterdata/role",
                name: "Role",
            },
            {
                image: homeInactive,
                url: "/masterdata/territories",
                name: "Territories",
            },
            {
                image: homeInactive,
                url: "/masterdata/privacy_policies",
                name: "Privacy Policies",
            },
            {
                image: homeInactive,
                url: "/masterdata/terms",
                name: "Terms of Use",
            },
        ],
    },
    {
        image: contactsInactive,
        url: "/appusers",
        name: "App Users",
        activeImage: contactsActive,
    },
];

function SideNav(props) {
    const [progress, setProgessbar] = useState();
    const [ACTIVE, setISACTIVE] = useState("/home");
    const [SUBMENUACTIVE, setSUBMENUACTIVE] = useState("");

    useEffect(() => {
        setProgessbar(window.location.pathname);
    }, [progress]);

    const subMenuHandle = (item, i, url) => {
        setSUBMENUACTIVE(item.url);
    };



    const getSteps = async () => {
        await getMethod(urls.getCustomerStripeId).then((response) => {
            if (response.status === 200) {
                // onHoldModal(true)  
                props.func(response.data.on_hold_check_flag);
            }
        });
    };

    const menuHandle = (location, indexMain, item) => {
        // console.log(navLinksAfterOnboarding[indexMain].url,location.pathname)
        // getSteps()

        if (navLinksAfterOnboarding[indexMain].url === location.pathname) {
            getSteps()
        }
        let path = location.pathname.slice(1);
        let afterSplit = path.split("/");
        setISACTIVE(`/${afterSplit[0]}`);
        setSUBMENUACTIVE(location.pathname);


        // if(ACTIVE.substring(1)===name.toLowerCase()){
        //     getSteps()
        // }


        for (let i = 0; i < navLinksAfterOnboarding.length; i++) {
            if (navLinksAfterOnboarding[i].url === location.pathname) {

                if (navLinksAfterOnboarding[i].submenus && navLinksAfterOnboarding[i].submenus.length > 0) {
                    subMenuHandle(navLinksAfterOnboarding[i].submenus[0]);

                }
            }
        }

        if (getUserRole() === "super-admin") {
            for (let i = 0; i < navLinksAfterOnboardingAdmin.length; i++) {
                if (navLinksAfterOnboardingAdmin[i].url === location.pathname) {
                    if (navLinksAfterOnboardingAdmin[i].submenus && navLinksAfterOnboardingAdmin[i].submenus.length > 0) {
                        subMenuHandle(navLinksAfterOnboardingAdmin[i].submenus[0]);
                    }
                }
            }
        }

        if (item !== undefined) {
            subMenuHandle(item[0], 0, item[0].url);
        }
    };

    const showSideNav = () => {
        if (getUserRole() === "super-admin") {
            return (
                <ul>
                    {navLinksAfterOnboardingAdmin.map(({ url, name, image, submenus, activeImage }, index) => (
                        <li>
                            <NavLink
                                key={name}
                                exact
                                to={url}
                                className={props.menu && ACTIVE === url ? "linkMenuActiveOnboard" : props.menu && ACTIVE !== url ? "linkMenuInActiveOnboard" : !props.menu && ACTIVE === url ? "link-activeOnboard" : "nav-link"}
                                isActive={(match, location) =>
                                    menuHandle(location, index, submenus)
                                }
                            >
                                <img
                                    src={ACTIVE === url ? activeImage : image}
                                    style={{
                                        height: 18,
                                        width: 18,
                                        justifySelf: "center",
                                        marginRight: "10px",
                                        marginLeft: "10px",
                                    }}
                                    alt=""
                                />
                                {name}
                            </NavLink>
                            {
                                <ul>
                                    {ACTIVE === url && !props.menu && submenus !== undefined && navLinksAfterOnboardingAdmin[index].submenus.map((item, i) => (
                                        <li>
                                            <NavLink
                                                key={i}
                                                exact
                                                to={item.url}
                                                isActive={(match, location) =>
                                                    console.log(location)
                                                }
                                                onClick={() => subMenuHandle(item, i, url)}
                                                className={SUBMENUACTIVE === item.url ? "submenu-link-active" : "submenu-nav-link"}
                                            >
                                                {item.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            }
                        </li>
                    ))}
                </ul>
            );
        } else if (!props.onBoardingStatus) {
            // console.log(!props.onBoardingStatus)
            return (
                <ul className="onProcessNav">
                    {navLinks.map(({ url, name, image, activeImage, status, step }) => (
                        // console.log(localStorage.getItem("progressStatus"), window.$step,status,status <= localStorage.getItem("progressStatus")),
                        <li>
                            <NavLink
                                key={name}
                                exact
                                to={() => url}
                                className={props.menu && ACTIVE === url ? "linkMenuActiveOnboard" : props.menu && ACTIVE !== url ? "linkMenuInActiveOnboard" : !props.menu && ACTIVE === url ? "link-activeOnboard" : "nav-link"}
                                isActive={(match, location) => setISACTIVE(location.pathname)}
                                style={{ pointerEvents: step <= window.$step ? "" : status <= (+window.$progressStatus?.split("%")?.[0]) ? "" : step <= localStorage.getItem("progressStatus") ? "" : "none" }}
                            // style={{ pointerEvents: status <= (+window.$progessPercentage?.split("%")?.[0]) ? "" : status <= (+window.$progressStatus?.split("%")?.[0]) ? "" : status <= (+localStorage.getItem("progressStatus")?.split("%")?.[0]) ? "" : "none" }}
                            >
                                <img
                                    src={ACTIVE === url ? activeImage : image}
                                    style={{
                                        height: 18,
                                        width: 18,
                                        justifySelf: "center",
                                        marginRight: "10px",
                                        marginLeft: "10px",
                                    }}
                                    alt=""
                                />
                                {name}
                            </NavLink>
                        </li>
                    ))
                    }
                </ul >
            );
        } else {
            return (
                <ul>
                    {navLinksAfterOnboarding.map(({ url, name, image, submenus, activeImage }, index) => (
                        <li>
                            <NavLink
                                key={name}
                                exact
                                to={url}
                                className={props.menu && ACTIVE === url ? "linkMenuActiveOnboard" : props.menu && ACTIVE !== url ? "linkMenuInActiveOnboard" : !props.menu && ACTIVE === url ? "link-activeOnboard" : "nav-link"}
                                isActive={(match, location) =>
                                    // console.log(index)
                                    menuHandle(location, index, submenus)
                                }
                            >
                                <img
                                    src={ACTIVE === url ? activeImage : image}
                                    style={{
                                        height: 18,
                                        width: 18,
                                        justifySelf: "center",
                                        marginRight: "10px",
                                        marginLeft: "10px",
                                    }}
                                    alt=""
                                />
                                {name}
                            </NavLink>
                            {
                                <ul>
                                    {ACTIVE === url && !props.menu && submenus !== undefined && navLinksAfterOnboarding[index].submenus.map((item, i) => (
                                        <li>
                                            <NavLink
                                                key={i}
                                                exact
                                                to={item.url}
                                                isActive={(match, location) =>
                                                    console.log(location)
                                                }
                                                onClick={() => subMenuHandle(item, i, url)}
                                                className={SUBMENUACTIVE === item.url ? "submenu-link-active" : "submenu-nav-link"}
                                            >
                                                {item.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            }
                        </li>
                    ))}
                </ul>
            );
        }
    };

    return (
        <div className="sideNavigationContainer sideNav">
            <div className={props.menu ? "menuOnboarding active" : "menuOnboarding"}>
                {getUserRole() === "super-admin" ? (
                    <div className="container">
                        <div className="d-flex justify-content-center">
                            <img className="sidenavLogo mt-3" src={haderLogo} alt="" />
                        </div>
                        <div className="d-flex justify-content-center">
                            <img src={NoImage} className="sidenavImg" alt="" />
                        </div>
                        <div className="sidenavName mb-4 d-flex justify-content-center">
                            John Doe
                        </div>
                    </div>
                ) : (
                    " "
                )}
                <ul>{showSideNav()}</ul>
            </div>
        </div>
    );
}

export default SideNav;
